import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme, variant, isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';
import { CardImage } from './components/CardImage.style.js';
import mq from '../../utils/mediaQueries.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var padding = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["padding:var(--space-400);", ""], mq.s(css(["padding:var(--space-500);"])))), GLOBETROTTER, css(["padding:var(--space-300);", " ", " ", ""], mq.s(css(["padding:var(--space-500);"])), mq.m(css(["padding:36px;"])), function (_ref) {
  var $noBackground = _ref.$noBackground,
    $variant = _ref.$variant,
    $imagePosition = _ref.$imagePosition;
  return ($noBackground || $variant === 'article') && css(["padding:var(--space-400) 0 0;", ""], $imagePosition === 'top' && css(["padding:var(--space-400) 0 0;", " ", ""], mq.s(css(["padding:var(--space-400) 0 0;"])), mq.m(css(["padding:var(--space-500) 0 0;"]))));
})));
var getImageWidth = function getImageWidth(columns) {
  var quota = columns / 12;
  var percentage = quota * 100;
  return css(["--card-image-width:calc( ", "% - (var(--space-grid-gutter) * (12 / ", " - 1)) * ", " );"], percentage, columns, quota);
};
var template = variant('$imagePosition', {
  left: css(["", " grid-template-columns:minMax(0,var(--card-image-width)) minMax(0,1fr);grid-template-areas:'image content';"], function (_ref2) {
    var $imageWidth = _ref2.$imageWidth;
    return css(["", ""], getImageWidth($imageWidth));
  }),
  right: css(["", " grid-template-columns:minMax(0,1fr) minMax(0,var(--card-image-width));grid-template-areas:'content image';"], function (_ref3) {
    var $imageWidth = _ref3.$imageWidth;
    return css(["", ""], getImageWidth($imageWidth));
  }),
  top: css([""])
});
var Card = styled.div.withConfig({
  displayName: "Cardstyle__Card",
  componentId: "sc-ocwr18-0"
})(["display:grid;position:relative;height:100%;width:100%;grid-template-columns:minMax(0,1fr);grid-template-rows:min-content 1fr min-content;grid-template-areas:'image' 'content';", "{width:100%;height:auto;}", ""], CardImage, mq.s(css(["", ""], template)));
var CardWrapper = styled.div.withConfig({
  displayName: "Cardstyle__CardWrapper",
  componentId: "sc-ocwr18-1"
})(["display:flex;flex-direction:column;align-items:stretch;width:100%;height:100%;", ""], isDefaultTheme(css(["", ""], function (_ref4) {
  var $noBackground = _ref4.$noBackground;
  return !$noBackground && css(["box-shadow:var(--elevation-100);border-radius:var(--border-radius-500);overflow:hidden;"]);
})));
styled.div.withConfig({
  displayName: "Cardstyle__ConceptRowContainer",
  componentId: "sc-ocwr18-2"
})(["width:100%;text-align:left;"]);
var CardContentContainer = styled.div.withConfig({
  displayName: "Cardstyle__CardContentContainer",
  componentId: "sc-ocwr18-3"
})(["background-color:var(--color-background-surface-primary);color:var(--color-text);grid-area:content;display:flex;flex-direction:column;", " ", " ", " ", ""], padding, isDefaultTheme(css(["", ""], function (_ref5) {
  var $variant = _ref5.$variant,
    $isPortraitCard = _ref5.$isPortraitCard,
    $footerAtBottom = _ref5.$footerAtBottom;
  return $variant === 'hotel' && !$isPortraitCard && !$footerAtBottom && css(["", ""], mq.m(css(["flex-direction:row;justify-content:space-between;"])));
})), function (_ref6) {
  var $variant = _ref6.$variant;
  return $variant !== 'article' && css(["", ""], isGlobetrotter(css([".bg-surface-primary &,.bg-surface-primary-globe &{background-color:var(--color-white);}"])));
}, function (_ref7) {
  var $noBackground = _ref7.$noBackground;
  return $noBackground && css(["background-color:unset;"]);
});

export { Card, CardContentContainer, CardWrapper };
//# sourceMappingURL=Card.style.js.map
